/*
 * @Author: 阿宇 969718197@qq.com
 * @Date: 2025-03-20 14:58:10
 * @LastEditors: 阿宇 969718197@qq.com
 * @LastEditTime: 2025-03-20 15:44:05
 * @Description:
 */
const en = {
  officialPrice: "Official Price",
  price: 'Price',
  quantity: 'Quantity',
  buyNow: 'Buy Now',
  addToCart: 'Add to Cart',
  productDetail: 'Product Detail',
  product: 'Product',
  brand: 'Brand',
  productName: 'Product Name',
  unit: 'Unit',
  specification: 'Specification',
  specificationNum: 'Specification Quantity',
  description: 'Description',
  tips: 'Tips',
  dataLoadFailed: 'Data load failed',
  confirm: 'Confirm',
  quantityLessThanOne: 'Quantity less than 1',
  addToCartSuccess: 'Add to cart successfully',
  addToCartFailed: 'Add to cart failed',
  buyQuantity: 'Buy Quantity',
};

export default en;
